module.exports = __webpack_public_path__ + "img/skull_narrow_bj.f3e5c6e4.png";